<script setup lang="ts">
import {computed, ref} from "vue";
import type {AutoCompleteCompleteEvent} from "primevue/autocomplete";
import Autocomplete from "primevue/autocomplete";

type Props = {
    items: Array<Record<string, unknown>>;
    label?: string;
    dataKey?: string;
    multiple?: boolean;
    optionLabel?: string;
};

const props = withDefaults(defineProps<Props>(), {
    dataKey: "id",
    optionLabel: "name",
});

const modelValue = defineModel<Record<string, unknown> | Array<Record<string, unknown>> | null | undefined>();
const filteredItems = ref<Array<Record<string, unknown>>>([]);

// const isStringProperty = (arg: unknown): arg is string => {
//     return typeof arg === "string";
// };

const itemsComputed = computed(() => {
    const validatedItems: Array<Record<string, string | number>> = [];
    props.items.forEach((item) => {
        let validatedObj: Record<string, string | number> = {};

        for (const [key, value] of Object.entries(item)) {
            if (typeof value === "string" || typeof value === "number") {
                validatedObj[key] = value;
            }
        }

        if (Object.keys(validatedObj).length !== 0) {
            validatedItems.push(validatedObj);
        }
    });

    return validatedItems;
});

const search = (event: AutoCompleteCompleteEvent) => {
    filteredItems.value = itemsComputed.value.filter((item) => {
        if (
            props.multiple &&
            Array.isArray(modelValue.value) &&
            modelValue.value?.find((I) => I[props.dataKey] === item[props.dataKey])
        ) {
            return false;
        }

        const value = item[props.optionLabel];
        if (typeof value === "string") {
            return value.toLowerCase().includes(event.query.toLowerCase());
        }
    });
};
</script>
<template>
    <Autocomplete
        v-bind="$attrs"
        :suggestions="filteredItems"
        :optionLabel="optionLabel"
        :dataKey="dataKey"
        v-model="modelValue"
        @complete="search"
        forceSelection
        complete-on-focus
        :multiple="props.multiple"
    >
        <slot></slot>
        <template #chip="slotProps">
            <slot name="chip" v-bind="slotProps"></slot>
        </template>
    </Autocomplete>
</template>
